import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ApolloProvider } from '@apollo/client';
import ApolloServiceClient from './common/clients/ApolloServiceClient';

const ApolloServiceProvider = ({ children }) => {
    const [client, setClient] = useState(null);

    useEffect(() => {
        // added persistCache module to Apollo client to support offline mode.
        // persistCache using promise to initialise it's functionality
        // that's why this anonymous function was added
        (async () => {
            const apolloClient = await ApolloServiceClient.getClient();
            setClient(apolloClient);
        })();
    }, []);
    return client && <ApolloProvider client={client}>{children}</ApolloProvider>;
};

ApolloServiceProvider.propTypes = {
    children: PropTypes.element,
};

ApolloServiceProvider.defaultProps = {
    children: undefined,
};

export default ApolloServiceProvider;
